import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Button,
} from '@qodo/design-system';
import { spawn } from '../../utils/translations';
import { DisconnectProviderDialogProps } from './types';

export const DisconnectProviderDialog = (
  props: DisconnectProviderDialogProps,
) => {
  const { onSubmit, ...rest } = props;
  const { t } = useTranslation();

  const spawnModalContent = spawn('dialogs.disconnect-provider');
  const spawnModalActions = spawn('dialogs.disconnect-provider.action');

  return (
    <Dialog {...rest}>
      <DialogContent autoFocus={false} className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{spawnModalContent('title')}</DialogTitle>
          <DialogDescription>
            {spawnModalContent('description')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            className="bg-transparent focus-none"
            variant="outline"
            onClick={onSubmit}
          >
            {t('general.disconnect')}
          </Button>
          <DialogClose>
            <Button>{spawnModalActions('cancel')}</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
